import { Card, Checkbox, Flex, Grid, Select, Text, TextInput } from '@mantine/core';
import { IconCircle, IconCircleDotted, IconNetwork, IconRobotFace, IconUsers } from '@tabler/icons-react';
import { models, providers } from '../../constants/models';

const GeneratedContentForm = ({ generatedContent, handleChange }) => {
  if (!generatedContent.marketingChannel) {
    return;
  }

  return (
    <Card.Section inheritPadding py="md">
      <Grid>
        <Grid.Col span={{ base: 12, sm: 5 }}>
          <Text fw={500} mb={4} component="div">
            <Flex align="center">
              {generatedContent.name ? (
                <IconCircle size={16} style={{ marginRight: 8 }} />
              ) : (
                <IconCircleDotted size={16} style={{ marginRight: 8 }} />
              )}
              <span style={{ flexGrow: 1, fontSize: '15px' }}>
                Name
              </span>
            </Flex>
          </Text>
          <TextInput
            name="name"
            value={generatedContent.name}
            placeholder="New generated content"
            onChange={(e) => handleChange({ target: { name: 'name', value: e.target.value } })}
          />
        </Grid.Col>

        {!['folder'].includes(generatedContent.marketingChannel) && (
          <>
            <Grid.Col span={{ base: 12, sm: 2 }}>
              <Text fw={500} mb={4} component="div">
                <Flex align="center">
                  <IconRobotFace size={16} style={{ marginRight: 8 }} />
                  <span style={{ flexGrow: 1 }}>Provider</span>
                </Flex>
              </Text>
              <Select
                data={providers}
                value={generatedContent.provider}
                onChange={(value) => {
                  handleChange({ target: { name: 'provider', value } });
                }}
                placeholder="Type to search..."
                required={true}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 3 }}>
              <Text fw={500} mb={4} component="div">
                <Flex align="center">
                  <IconNetwork size={16} style={{ marginRight: 8 }} />
                  <span style={{ flexGrow: 1 }}>Model</span>
                </Flex>
              </Text>
              <Select
                w="100%"
                data={models[generatedContent.provider]}
                value={generatedContent.model}
                onChange={(value) => handleChange({ target: { name: 'model', value } })}
                placeholder="Type to search..."
                required={true}
              />
            </Grid.Col>
          </>
        )}

        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text fw={500} mb={4} component="div">
            <Flex align="center">
              <IconUsers size={16} style={{ marginRight: 8 }} />
              <span style={{ flexGrow: 1 }}>Shared in Account</span>
            </Flex>
          </Text>
          <Checkbox
            size="lg"
            checked={generatedContent.shared}
            onChange={(e) => handleChange({ target: { name: 'shared', value: e.currentTarget.checked } })}
          />
        </Grid.Col>
      </Grid>
    </Card.Section>
  );
};

export default GeneratedContentForm;
